import Styles from './styles.module.css';
import 'firebase/auth'
import React, { useEffect, useState } from 'react';
import DefaultImage from './../../../../image/default/logo.png';
import { FaPencilAlt } from 'react-icons/fa';
import { doc, getFirestore, updateDoc } from 'firebase/firestore';
import { getStorage, ref, uploadBytes } from 'firebase/storage';
import { useAppSelector } from 'src/salon/app/hook';
import { useNavigate } from 'react-router-dom';
import { AppDispatch } from 'src/salon/app/store';
import { useDispatch } from 'react-redux';
import { getAuth } from 'firebase/auth';

type ManualIconProps = {};

const ManualIcon: React.FC<ManualIconProps> = () => {

  const company = useAppSelector((state) => state.company.company);
  const navigate = useNavigate();

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (!company?.id || !styleImageFilePath) return;
    
    let cancelled = false;

    const checkImageExists = async (url: string) => {
      try {
        const res = await fetch(url, { method: "HEAD" });
        return res.ok;
      } catch {
        return false;
      }
    };

    const run = async () => {
      const url = `https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/companies_logo%2Fresize_images%2F${company.id}_200x200?alt=media&token=`;

      const exists = await checkImageExists(url);

      if (!exists || cancelled) return;
      
      const db = getFirestore();
      await updateDoc(doc(db, "companies", company.id), {
        "progress.icon": true,
      });

      if (cancelled) return;

      navigate("../job", { replace: true });
    };

    run();

    return () => {
      cancelled = true;
    };
  }, [company?.id, navigate]);

  const [error, setError] = useState(false);
  const [uploading, setUploading] = useState(false);

  // Windows(desktop/index.tsxで全体にzoom:0.8がかかっている)では、
  // 内側の要素がCSSのmin-height:100vhをそのまま使うとzoomで縮小された分
  // 画面下部が余って背景が途切れるため、ズーム分を逆算した高さで
  // 上書きする(desktop/index.tsxのMainラッパーと同じ対処)。
  const isWindows = navigator.userAgent.includes("Windows");

  const [styleImageFile, setStyleImageFile] = useState<string>('');
  const [styleImageFilePath, setStyleImageFilePath] = useState<File | null>(null);

  // 画像選択
  const styleImages = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setStyleImageFile(URL.createObjectURL(e.target.files[0]));
      setStyleImageFilePath(e.target.files[0]);
    }
  };

  // -------------------------
  // 保存処理
  // -------------------------
  async function save() {
    if (!company?.id) return;

    if (!styleImageFilePath) {
      setError(true);
      return;
    }

    const db = getFirestore();
    const storage = getStorage();

    try {
      setError(false);
      setUploading(true);

      // アップロード
      const logoRef = ref(storage, `/companies_logo/${company.id}`);
      await uploadBytes(logoRef, styleImageFilePath);

      // Firestore更新
      const refs = doc(db, 'companies', company.id);
      await updateDoc(refs, {
        'progress.icon': true,
      });

      // 次へ
      navigate('../job', { replace: true });

    } catch (e) {
      console.error(e);
      setError(true);
    } finally {
      setUploading(false);
    }
  }

  return (
    <div className={Styles.plan} style={{ minHeight: isWindows ? '125vh' : undefined }}>
      <div className={Styles.inner}>

        <p className={Styles.kicker}>STEP 2</p>
        <h1 className={Styles.title}>会社アイコンを設定</h1>
        <p className={Styles.lead}>
          学生アプリや求人票に表示されるアイコンです。設定後もいつでも変更できます。
        </p>

        <section className={Styles.card}>
          <div className={Styles.make_imageWrapper}>

            <input
              type="file"
              onChange={styleImages}
              disabled={uploading}
              className={Styles.fileInput} />

            {/* 画像 */}
            <img
              className={Styles.make_image_file}
              src={styleImageFile || DefaultImage}
              alt=''
            />

            {/* loading overlay */}
            {uploading && (
              <div className={Styles.overlay}>
                <div className={Styles.spinner} />
              </div>
            )}

            {/* アイコン */}
            {!uploading && (
              <FaPencilAlt className={Styles.make_image_pen} />
            )}

          </div>

          {error && (
            <p className={Styles.errorText}>アイコンを選択してください。</p>
          )}

          <button
            type='button'
            className={Styles.primary}
            onClick={save}
            disabled={uploading}
            style={{ opacity: styleImageFile ? 1 : 0.5 }}
          >
            {uploading ? 'アップロード中…' : '確定する'}
          </button>
        </section>

      </div>
    </div>
  );
}

export default ManualIcon;